import { useEffect } from 'react';

import router from 'next/router';

/**
 * Checks if the prevUrl is an article page, if yes returns back to article page manually.
 */
export const useBackToArticle = () => {
	const onBackButtonEvent = (event: Event) => {
		event.preventDefault();

		const prevUrl = window.history.state.prevUrl;

		if (prevUrl) {
			router.push(window.history.state.prevUrl);
		} else {
			return;
		}
	};

	useEffect(() => {
		window.addEventListener('popstate', onBackButtonEvent);

		return () => {
			window.removeEventListener('popstate', onBackButtonEvent);
		};
	}, []);
};
